<template>
  <div
    class="row"
  >
    <div class="col-lg-12 col-xs-12">
      <span class="ml-3 f14 font-weight-bold">TRAINEE - CONFIGURAÇÕES</span>
    </div>
    <div class="col-lg-4 col-xs-12 mt-2 ml-3">
      <span class="ml-3 f14 font-weight-bold mb-2">DATA DE FORMAÇÃO MÍNIMA</span>
      <Datepicker
        type="datetime"
        v-model="job.trainee_start_date"
        input-class="form-control bg-white"
        :language="ptBR"
        format="yyyy"
        minimum-view="year"
        @input="save"
      ></Datepicker>
    </div>
    <div class="col-lg-4 col-xs-12 mt-2 ml-3">
      <span class="ml-3 f14 font-weight-bold mb-2">DATA DE FORMAÇÃO MÁXIMA</span>
      <Datepicker
        type="datetime"
        v-model="job.trainee_end_date"
        input-class="form-control bg-white"
        :language="ptBR"
        format="yyyy"
        minimum-view="year"
        @input="save"
      ></Datepicker>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";

export default {
  props: [
    "job_record",
  ],

  components: {
    Datepicker,
  },
 
  data() {
    return {
      job: {
        trainee_start_date: null,
        trainee_end_date: null,
      },
      ptBR,
    }
  },

  mounted() {
    this.job.trainee_start_date = this.job_record?.years_valid_trainee[0];
    this.job.trainee_end_date = this.job_record?.years_valid_trainee[1];
  },

  methods: {
    save() {
      this.$emit("save", this.job);
    },
  },

  watch: {
    "job_record.years_valid_trainee"() {
      if (this.job_record){
        if (
          this.job_record?.years_valid_trainee?.includes(this.job.trainee_start_date) &&
          this.job_record?.years_valid_trainee?.includes(this.job.trainee_end_date)
        ) return;
        this.job.trainee_start_date = this.job_record?.years_valid_trainee[0];
        this.job.trainee_end_date = this.job_record?.years_valid_trainee[1];
      }
    }
  },


}
</script>
